import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import './plugins/vuetify'
import './plugins/elementUi'
import App from './App.vue'
import router from './router'
import store from './store'
import Amplify from 'aws-amplify'

// var awsConfig
// if (location.host.startsWith('localhost')) { // 開発環境
//   awsConfig = '@/.config/aws-exports-local.js'
// } else { // QA環境
//   awsConfig = '@/.config/aws-exports.js'
// }
// let awsExports = awsConfig
import awsExports from '@/.config/aws-exports-local.js'

Amplify.configure(awsExports)
// Amplify.Logger.LOG_LEVEL = 'DEBUG'

Vue.config.productionTip = false

sync(store, router)

Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
